import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
} from 'chart.js'
import { Chart } from 'react-chartjs-2'
import { EmptyState } from '../EmptyState'
import clsx, { ClassValue } from 'clsx'
import { LoadingState } from '../LoadingState'
import { ErrorState } from '../ErrorState'

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
)

export type MixedChartProps = {
  title?: string
  legend?: {
    position: 'top' | 'bottom' | 'right' | 'left'
  }
  data?: {
    labels?: string[]
    datasets?: {
      type: 'line' | 'bar'
      label: string
      backgroundColor: string | string[]
      data: number[]
      borderColor?: string
      borderWidth?: number
      fill?: boolean
      spanGaps?: boolean
      borderDash?: any
      radius?: number
    }[]
  }
  stacked?: boolean | false
  loading?: boolean
  error?: boolean
  className?: ClassValue
}

export function MixedChart (props: MixedChartProps) {
  const { title, legend, data, stacked, loading, error, className } = props

  const labels = data?.labels
  const datasets = data?.datasets

  const isEmpty = !datasets || datasets.flatMap(item => item.data).length === 0

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: legend || { display: false },
      title: {
        display: !!title,
        text: title
      }
    },
    scales: {
      x: {
        grid: {
          color: 'transparent'
        },
        stacked
      },
      y: {
        min: 0,
        stacked
      }
    }
  }

  return (
    <>
      {error && <ErrorState />}
      {!error && loading && <LoadingState />}
      {isEmpty && !loading && !error && <EmptyState />}
      {!error && !loading && !isEmpty && datasets && labels && (
      <div className={clsx(className, 'h-full')}>
        <Chart
          type='bar'
          options={options}
          data={{
            datasets,
            labels
          }}
        />
      </div>)}
    </>
  )
}
